import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { UPLOAD_FACADE } from '@dges/modules/storage/domain';
import { FirebaseUploadFacade } from './+state/upload.facade';

export function provideStorageNgrxStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: UPLOAD_FACADE, useExisting: FirebaseUploadFacade },
  ]);
}
